import React, { useRef, useState, useEffect } from "react";
import Moment from 'react-moment';
import 'moment/locale/es';
import 'moment-timezone';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faSignInAlt, faSignOutAlt, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import QrScanner from 'components/QrScanner';


import LoaderButton from "../components/LoaderButton";
import Loader from "./Loader";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

// Helper function to convert UTC to Guatemala time
const formatGuatemalaTime = (dateString) => {
    if (!dateString) return '';
    return moment.utc(dateString).tz('America/Guatemala').format('DD/MM/YYYY HH:mm');
};

// const API_NAME = "offline"
const API_NAME = "vivelo"

export default function AdmissionListControl({show, showTicket, showLocation, onClose, testMode=false, ...props}) {
    
    const [ticket, setTicket] = useState(null);
    const [status, setStatus] = useState('loading');
    const [showAdmission, setShowAdmission] = useState(false);
    const [searchResults, setSearchResults] = useState(null);
    const [selectedResult, setSelectedResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [fields, handleFieldChange] = useFormFields({
        search: ""
    });

    async function getSearchResults(show) {
        const searchQuery = fields.search ? `&search=${fields.search}` : ''
        const ticket = ''; //showTicket ? `&ticket=${showTicket}` : ''
        const location = showLocation ? `&location=${showLocation._id}` : ''
        const limit = `&limit=100`
        const query = `/cart/orders?show=${show._id}&status=APPROVED${ticket}${location}${searchQuery}${limit}`
        const results = await API.get("vivelo", query);
        if (results && results?.items) {
            setSearchResults(results.items)
            // setTotalRows(results.total || 0)
            return results.items
        }
        return []        
    }

    async function validateCode(code, code2, show_uid, ticket_uid, operation, requireCheckin) {
        try {
            const checkin = (operation === 'checkin') ? '&checkin=1' : (operation === 'checkout' ? '&checkout=1' : '')
            const ticket = ticket_uid ? `&t=${ticket_uid}` : ''
            const location = showLocation ? `&l=${showLocation._id}` : ''
            const result = await API.get(API_NAME, `/etickets/${operation}/${code}?s=${show_uid}&code2=${code2}${ticket}${location}${checkin}${requireCheckin}`);
            return result
        } catch (e) {
            console.log(e)
            if (e.response && e.response.data) {
                return e.response.data
            } else {
                return {
                    success: false,
                    allow_access: false,
                    error_code: 'API_ERROR'
                }
            }
        }
    }
    
    async function handleValidate(ticket, vcode) {
        setStatus('validating')

        const show_uid = show._id
        const ticket_uid = null; //showTicket
        const code = ticket.code.substring(5)
        const code2 = vcode.code2.substring(5)
        
        // Determine operation based on current ticket status
        const checkedin = vcode.checkedin_on
        const checkedout = vcode.checkedout_on
        
        let operation = 'checkin'
        let requireCheckin = ''
        
        if (checkedin && !checkedout && show.settings.needs_checkout) {
            operation = 'checkout'
            requireCheckin = '&requireCheckin=true'
        }
        
        const result = await validateCode(code, code2, show_uid, ticket_uid, operation, requireCheckin)

        if (result.success) {
            if (result.allow_access) {
                setTicket(result.ticket)
                setStatus('accepted')
                
                if (operation === 'checkout') {
                    vcode.checkedout_on = result.checkedout
                } else {
                    vcode.checkedin_on = result.checkedin
                }

                setSelectedResult({ ... selectedResult })
            } else {
                setTicket(result.ticket)
                setStatus('warning')
            }
        } else {
            // Handle error cases with specific error codes
            if (result.error_code) {
                result.ticket = result.ticket || {}
                result.ticket.error_code = result.error_code
            }
            setTicket(result.ticket)
            setStatus('rejected')
        }
    }

    function getErrorMessage(errorCode) {
        switch(errorCode) {
            case 'ALREADY_CHECKED_OUT':
                return 'Ya registró salida anteriormente';
            case 'CHECKIN_FAILED':
                return 'No se pudo registrar ingreso - ya registrado o con salida previa';
            case 'CHECKOUT_FAILED':
                return 'No se pudo registrar salida';
            case 'NO_PREVIOUS_CHECKIN':
                return 'No se encontró ingreso previo para registrar salida';
            case 'INVALID_CODE':
                return 'Código inválido';
            case 'INVALID_QR_FORMAT':
                return 'Formato de código QR inválido';
            case 'MISSING_CODE':
                return 'Falta el parámetro de código';
            case 'INTERNAL_ERROR':
                return 'Error interno del servidor';
            case 'API_ERROR':
                return 'Error de conexión con el servidor';
            default:
                return 'Error al procesar operación';
        }
    }

    function handleShowAdmission() {
        setTicket(null)
        setStatus('loading')
        setShowAdmission(!showAdmission)
    }  
    
    function exitScanner() {
        setTicket(null)
        setStatus('loading')
        onClose()
    }

    function renderStatusBar() {
        switch(status) {
            case 'scanning':
                return <Alert variant="info">
                    <FontAwesomeIcon icon={faQrcode} /> 
                    Buscando boletos...
                </Alert>
            case 'validating':
                return <Alert variant="primary">
                    <FontAwesomeIcon icon={faSpinner} className="spinning" /> 
                    Validando...
                </Alert>
            case 'accepted':
                return <Alert variant="success">
                    <FontAwesomeIcon icon={faCheckCircle} /> 
                    Operación registrada exitosamente
                </Alert>
            case 'warning':
                return <Alert variant="warning">
                    <FontAwesomeIcon icon={faExclamationTriangle} /> 
                    Boleto válido. No registra operación.
                </Alert>
            case 'rejected':
                return <Alert variant="danger">
                    <FontAwesomeIcon icon={faTimesCircle} /> 
                    {ticket && ticket.error_code ? getErrorMessage(ticket.error_code) : 'Boleto inválido'}
                </Alert>
            default: 
                return <></>
        }
    }

    function buildResultTicketFilter(ticket) {
        let resultFilter = ['VENUE_OPEN','VENUE_SEAT','VENUE_TABLE_SEAT'].includes(ticket.ticket_type)
        if (showLocation) {
            console.log(ticket?.seat?.location_uid, ticket)
            resultFilter &= ticket?.seat?.location_uid == showLocation._id
        }

        return resultFilter
    }
    function buildResultCodeFilter(code) {
        let resultFilter = ['VENUE_OPEN','VENUE_SEAT','VENUE_TABLE_SEAT'].includes(code.ticket_type)
        if (showLocation) {
            console.log(code.location_uid)
            resultFilter &= code.location_uid == showLocation._id
        }

        return resultFilter
    }

    function renderSearchResults() {
        let list = <></>
        try {

            if (searchResults) {
                list = searchResults
                    .filter(r => r.status == 'APPROVED')
                    .filter(r => {
                        return r.codes
                            .filter(buildResultCodeFilter)
                            //.filter(ticket => ticket.ticket_uid == showTicket._id)
                            .length > 0
                    })
                    .map(r => {
                        const codes = r.codes.filter(buildResultCodeFilter)
                        const codeCount = codes.length

                        const checkedinCount = codes.filter(c => {
                            return r.vcode.find(vc => vc.code == c.code && vc.checkedin_on)                            
                        }).length

                        const checkedoutCount = codes.filter(c => {
                            return r.vcode.find(vc => vc.code == c.code && vc.checkedout_on)                            
                        }).length

                        const check = codeCount == checkedinCount ? <FontAwesomeIcon icon={faCheckCircle} style={{color: 'green'}} /> : null
                        const checkoutCheck = show.settings.needs_checkout && codeCount == checkedoutCount ? <FontAwesomeIcon icon={faSignOutAlt} style={{color: 'blue'}} /> : null

                    return <div className="show-admission-search-result" onClick={() => { 
                        setSelectedResult(r)
                    }}>
                        <div className="search-result-secondary">Orden #{r._id}</div>                     
                        <div className="search-result-main">{r.payment_info.firstname} {r.payment_info.lastname}</div>
                        <div className="search-result-secondary">{r.payment_info.email}</div>
                        {r.payment_info?.reference && <div className="search-result-secondary">Ref: {r.payment_info.reference}</div>}
                        <div className="search-result-secondary">{codeCount} boletos / {checkedinCount} ingresos {check}</div>
                        {show.settings.needs_checkout && (
                            <div className="search-result-secondary">{checkedoutCount} salidas registradas {checkoutCheck}</div>
                        )}
                    </div>
                })
            }

            return <div className="show-admission-search-result-list">
                {list.length > 0 ? list : null}
            </div>

        } finally {
        }
    }

    function renderOrderTickets(order) {

        const ticketList = order.codes
            .filter(buildResultCodeFilter)
            // .filter(ticket => ticket.ticket_uid == showTicket._id)
            .map(ticket => {

                const vcode = order.vcode.find( c => c.code == ticket.code)
                let checkedin = false
                let checkedout = false
                let clazz = ''
                if (vcode) {
                    checkedin = vcode.checkedin_on
                    checkedout = vcode.checkedout_on
                }
                if (checkedout) {
                    clazz = 'checkedout'
                } else if (checkedin) {
                    clazz = 'checkedin'
                }
                const ticketBackground = ticket?.qrcolor?.qr_light_color || ''
                const ticketForeground = ticket?.qrcolor?.qr_dark_color || '000000FF'                

            return <div className={`ticket ${clazz}`} key={vcode ? vcode._id : ticket.code}>
                <div className="ticket-data" style={{background:`#${ticketBackground}`,color:`#${ticketForeground}`}}>                            
                    <div className="ticket-data-item"><label>Boleto</label><span
                        style={{fontSize:'1.8rem',fontWeight:'bold'}}>
                            {ticket.ticket_name}
                    </span></div>
                    <div className="ticket-data-item"><label>Código</label><span>{ticket.code.substring(5)}</span></div>
                </div>
                <div className="ticket-data">
                    <div className="ticket-data-item"><label>Sección</label><span>{ticket.section}</span></div>
                    <div className="ticket-data-item"><label>Puerta</label><span>{ticket.door}</span></div>                            
                </div>
                {ticket && ticket.row && ticket.seat && <div className="ticket-data">
                    <div className="ticket-data-item"><label>Fila</label><span>{ticket.row}</span></div>
                    <div className="ticket-data-item"><label>Asiento</label><span>{ticket.seat}</span></div>
                </div> }
                
                {/* Status and action section */}
                {vcode ? (
                    <div className="ticket-status-section">
                        {/* Status Flow Display */}
                        <div className="ticket-status-flow">
                            {/* Checkin Status */}
                            <div className="status-step">
                                <div className="status-indicator">
                                    {checkedin ? (
                                        <FontAwesomeIcon icon={faCheckCircle} className="status-icon success" />
                                    ) : (
                                        <FontAwesomeIcon icon={faTimesCircle} className="status-icon pending" />
                                    )}
                                </div>
                                <div className="status-label">Ingreso</div>
                                {checkedin && (
                                    <div className="status-time">
                                        <span style={{fontSize: 10}}>{formatGuatemalaTime(checkedin)}</span>
                                    </div>
                                )}
                            </div>

                            {/* Arrow to Checkout (if checkout enabled) */}
                            {show.settings.needs_checkout && (
                                <div className="status-arrow">
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </div>
                            )}

                            {/* Checkout Status (if enabled) */}
                            {show.settings.needs_checkout && (
                                <div className="status-step">
                                    <div className="status-indicator">
                                        {checkedout ? (
                                            <FontAwesomeIcon icon={faCheckCircle} className="status-icon success" />
                                        ) : checkedin ? (
                                            <FontAwesomeIcon icon={faExclamationTriangle} className="status-icon warning" />
                                        ) : (
                                            <FontAwesomeIcon icon={faTimesCircle} className="status-icon pending" />
                                        )}
                                    </div>
                                    <div className="status-label">Salida</div>
                                    {checkedout && (
                                        <div className="status-time">
                                            <span style={{fontSize: 10}}>{formatGuatemalaTime(checkedout)}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                        
                        {/* Action Buttons */}
                        <div className="ticket-actions">
                            {/* Checkin Button - Show if not checked in */}
                            {!checkedin && (
                                <Button 
                                    variant="success" 
                                    size="sm"
                                    onClick={() => handleValidate(ticket, vcode)}
                                >
                                    <FontAwesomeIcon icon={faSignInAlt} /> Registrar Ingreso
                                </Button>
                            )}
                            
                            {/* Checkout Button - Show if checked in but not checked out */}
                            {checkedin && !checkedout && show.settings.needs_checkout && (
                                <Button 
                                    variant="info" 
                                    size="sm"
                                    onClick={() => handleValidate(ticket, vcode)}
                                >
                                    <FontAwesomeIcon icon={faSignOutAlt} /> Registrar Salida
                                </Button>
                            )}
                            
                            {/* Completed Status - Show if both checkin and checkout done */}
                            {checkedin && checkedout && show.settings.needs_checkout && (
                                <div className="completion-status">
                                    <Badge variant="success">COMPLETO</Badge>
                                </div>
                            )}
                            
                            {/* Only Checkin Done - Show if checkout not enabled */}
                            {checkedin && !show.settings.needs_checkout && (
                                <div className="completion-status">
                                    <Badge variant="success">ADMITIDO</Badge>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="ticket-data">
                        <Badge variant="danger">INVÁLIDO</Badge>
                    </div>
                )}
                
            </div>
        });

        return ticketList
    }

    function renderLoading() {
        return <div style={{color:'red', height:100}}><Loader /></div>
    }

    function handleSearchSubmit(e) {
        e.preventDefault();
        try {
            setIsLoading(true)

            setSearchResults([])
            getSearchResults(show)
        } finally {
            setIsLoading(false)
        }
    }
    function renderAdmissionList() {
        
        // Determine layout class - no mode toggle needed for list view
        const layoutClass = 'list-layout'
        
        return show && <div className="scanner-container">
                <h1>Admisión por Listado</h1>
                
                {(showTicket || showLocation) && <div className={`show-admission ${layoutClass}`}>
                    <div className="show-admission-header">                        
                        <h1>{show.fullname}</h1>
                        <Button onClick={exitScanner} className="exit" variant="outline-light">Cerrar</Button>
                        <h2>{show?.settings?.hasMap ? showTicket.fullname : `Listado`}</h2>
                    </div>
                    
                    
                    { !selectedResult && <div className={`show-admission-list`}>
                        <div className="show-admission-list-header">                            
                        {/* <form onSubmit={(e) => { e.preventDefault(); getSearchResults(show) }}> */}
                        <form onSubmit={handleSearchSubmit}>
                            <input type="text" 
                            value={fields.search}
                            name="search"
                            id="search"
                            onChange={handleFieldChange} /><Button type="submit" variant="info" size="sm">Buscar</Button>
                        </form>  
                        </div>
                        <div>
                            {isLoading ? renderLoading() : renderSearchResults()}
                        </div>
                    </div> }
                    { selectedResult && <div className={`show-admission-result `}>
                        <div className="show-admission-result-back">
                            <a href="#" onClick={() => {
                                setStatus(null)
                                setSelectedResult(null)
                            }}><FontAwesomeIcon icon={faChevronLeft} /> Regresar</a>
                            {renderStatusBar()}
                        </div>
                        <div className="show-admission-result-info">
                            <div>Orden #{selectedResult._id}</div>
                            <div style={{fontWeight:'bold'}}>{`${selectedResult.payment_info.firstname} ${selectedResult.payment_info.lastname} `}</div>
                            <div>{ selectedResult.payment_info.email }</div>
                            <div><Moment format='LLL' locale="es" >{ selectedResult.createdAt }</Moment></div>
                            <div>{selectedResult.codes
                                .filter(buildResultCodeFilter)
                                // .filter(ticket => ticket.ticket_uid == showTicket._id)
                                .reduce( (p, c) => p + 1, 0 )
                                }{` boletos`}</div>
                        </div>
                        <div className="show-admission-result-tickets">
                        { renderOrderTickets(selectedResult) }
                        </div>
                        <div style={{height: 200}}></div>
                    </div> }
                </div> }
        </div>
    }
    
    return (        
        

        show ? <>    
            <div>
                    {renderAdmissionList()}
            </div>
        </> : null
  );


}